import * as anltx from 'mk/anltx';
import * as bzforms from 'mk/bzforms';
import { csrfToken } from 'mk/common/csrfToken';
import * as responsive from 'mk/common/responsive';
import * as msgs from 'mk/msgs';
import * as hb from 'mk/ox';
import { reactInit } from 'mk/ox/react';
import { API_VERSION_STRING } from 'mk/settings';
import * as xhr from 'mk/xhr/client';
import { observeBlogPostsForTrackReach, trackReach } from 'mk2/trackReach';
import * as auth from './auth';
import * as fupload from './fupload';
import * as jam from './jam';
import { initJqueryAjaxCsrf } from './jquery.ajax.csrf';
import * as like from './like';
import { initJqueryModal } from './modal';
import * as initPrivacyReminder from './privacyReminder';
import * as sharing from './sharing';

declare const window: any;
declare const ASMIRA: any;

window.getCSRFToken = csrfToken;
initJqueryAjaxCsrf();
initJqueryModal();

window.xhr = xhr;

window.msgs = msgs;

anltx.initBrowser();
window.anltx = anltx;

window.bzforms = bzforms;

// WARNING: window.responsive.isMqMobile() is used in the Google Tag Manager
window.responsive = responsive;

window.MK_API_VERSION_STRING = API_VERSION_STRING;

window.mk__system__fupload = fupload;
window.mk__system__initPrivacyReminder = initPrivacyReminder;

window.jam = jam;
window.auth = auth;
window.Like = like;
window.Sharing = sharing;
window.trackReach = trackReach;
window.observeBlogPostsForTrackReach = observeBlogPostsForTrackReach;

window.hb = hb;
// Extend ox with ability to mount react components
window.hb.reactInit = reactInit;

// backward-compat
window.float_alert = msgs.alert;
window.float_error = msgs.error;
